var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlickfangIconArrowSmallSchwarz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.36 20.2",
    style: {
      enableBackground: "new 0 0 18.36 20.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "16.47,9.34 10.52,15.13 10.52,0 7.82,0 7.82,15.11 1.88,9.34 -0.01,11.27 9.18,20.2 18.36,11.27  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlickfangIconArrowSmallSchwarz);
export default __webpack_public_path__ + "static/media/blickfang_Icon-arrow-small-schwarz.1cd6fd6715457d0dc52fec8be7a62fda.svg";
export { ForwardRef as ReactComponent };